import { z } from "zod";
import { GeneratedSkedApiClient } from "api/generated-client";
import type { components, paths } from "api/generated/sked-api-openapi-types";

export type AssetVision = components["schemas"]["VisionAnalysisResponse"];
const client = new GeneratedSkedApiClient<paths>();
const visionResponse: z.ZodType<AssetVision> = z.object({
  assetId: z.string().min(1),
  inboxEntryId: z.string().min(1),
  status: z.enum(["not-analyzed", "failed", "complete", "skipped-too-long"]),
  canAnalyze: z.boolean(),
  maxVideoDurationSeconds: z.number().finite().positive(),
  visionDescription: z.string(),
  tags: z.array(z.string()),
  reason: z.string().optional(),
});

export async function getAssetVision(assetId: string, signal: AbortSignal) {
  const result = await client.client.GET("/content-inbox/{assetId}/vision", {
    params: { path: { assetId } },
    signal: AbortSignal.any([signal, AbortSignal.timeout(100000)]),
  });
  return visionResponse.parse(await client.unwrap(result));
}

export async function analyzeAssetVision(assetId: string, signal: AbortSignal) {
  const result = await client.client.POST(
    "/content-inbox/{assetId}/vision/analyze",
    {
      params: { path: { assetId } },
      signal: AbortSignal.any([signal, AbortSignal.timeout(100000)]),
    }
  );
  return visionResponse.parse(await client.unwrap(result));
}
